// extracted by mini-css-extract-plugin
export default {"text":"Resources_text__e8-wC","inner":"Resources_inner__euiob","part":"Resources_part__Q+oWj","heading":"Resources_heading__aXq2B","linkResources":"Resources_linkResources__8ozJD"};